export const CONTRACT_FAMILIES_TAGS = {
  CONTRACT_FAMILIES_TAG: "ContractFamilies",
  CONTRACT_FAMILY_GROUPING_JOB_TAG: "ContractFamilyGroupingJob",
  CONTRACT_FAMILY_REVIEW_QUEUE_TAG: "ContractFamilyReviewQueue",
  CONTRACT_FAMILY_SUMMARIES_TAG: "ContractFamilySummaries",
  CONTRACT_FAMILY_SUMMARY_JOB_TAG: "ContractFamilySummaryJob",
  CONTRACT_FAMILY_PIPELINE_RUN_TAG: "ContractFamilyPipelineRun",
  CONTRACT_FAMILY_PIPELINE_CONFIGURATION_TAG: "ContractFamilyPipelineConfiguration",
  CONTRACT_FAMILY_AUTOMATED_RUN_TAG: "ContractFamilyAutomatedRun",
} as const;
